import { Parser } from 'marked';
import { MarkedOptions, MarkedRenderer } from 'ngx-markdown';

// function that returns `MarkedOptions` with renderer override
export function markedOptionsFactory(): MarkedOptions {
  const renderer = new MarkedRenderer();

  renderer.heading = ({ tokens, depth }) => {
    return `<h${depth} class="changelog-section-title mb-4 mt-3">
        ${Parser.parseInline(tokens)}
      </h${depth}>`;
  };

  renderer.link = ({ tokens }) => {
    return `<span>${Parser.parseInline(tokens)}</span>`;
  };

  renderer.listitem = ({ tokens }) => {
    return `<li class="changelog-list-item"> ${Parser.parseInline(tokens)}</li>`;
  };

  return {
    renderer: renderer,
  };
}
